import { render } from "./MainMobile.vue?vue&type=template&id=6d217b5a"
import script from "./MainMobile.vue?vue&type=script&lang=js"
export * from "./MainMobile.vue?vue&type=script&lang=js"

import "./MainMobile.vue?vue&type=style&index=0&id=6d217b5a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__